/**
 * @fileoverview
 * Route path segments for audit modules. Use in route definitions (*.routes.ts)
 * and in audit-routes.config so paths stay in sync.
 *
 * @version 1.0.0
 * @author KATALYST TEAM
 */

/** List tab segments */
export const LIST_TAB = {
  ALL: 'all',
  THIS_WEEK: 'this-week',
  UPCOMING: 'upcoming',
} as const;

/** Cash audit */
export const CASH_ROUTE = {
  PROCESS: 'cash-audit-process',
  CAPTURE_DRAWER: 'capture-drawer',
  DENOMINATION: 'denomination-entry',
  REGISTER_IMAGE: 'register-image',
  VARIANCE: 'variance',
  ACKNOWLEDGE: 'acknowledge',
} as const;

/** Security audit */
export const SECURITY_ROUTE = {
  PROCESS: 'security-audit-process',
  SECURITY_STATUS: 'security-status',
  VARIANCE: 'variance',
  ACKNOWLEDGE: 'acknowledge',
} as const;

/** Gold verification */
export const GOLD_VERIFICATION_ROUTE = {
  SEGMENT: 'gold-verification',
  BRANCH_DETAILS: 'branch-details',
  AUDIT_PROCESS: 'gold-verification-audit-process',
  VERIFICATION: 'verification',
  VARIANCE: 'variance',
  ACKNOWLEDGE: 'acknowledge',
} as const;

/** Valuation tool */
export const VALUATION_TOOL_ROUTE = {
  SEGMENT: 'valuation-tool',
  PROCESS: 'valuation-tool-audit-process',
  STATUS: 'valuation-tool-status',
  VARIANCE: 'variance',
  ACKNOWLEDGE: 'acknowledge',
} as const;

/** Packet inventory */
export const PACKET_INVENTORY_ROUTE = {
  PROCESS: 'packet-inventory-audit-process',
  PACKET_VERIFICATION: 'packet-verification',
  VARIANCE_CHECK: 'variance-check',
  ACKNOWLEDGE: 'acknowledge',
} as const;

/** Tare weight */
export const TARE_WEIGHT_ROUTE = {
  PROCESS: 'tare-weight-audit-process',
  VERIFICATION: 'tare-weight-verification',
  VARIANCE: 'variance',
  ACKNOWLEDGE: 'acknowledge',
} as const;

/** Registers and statutory */
export const REGISTERS_STATUTORY_ROUTE = {
  PROCESS: 'registers-and-statutory-audit-process',
  REGISTERS: 'registers',
  STATUTORY: 'statutory',
  VARIANCE: 'variance',
  ACKNOWLEDGE: 'acknowledge',
} as const;

/** Asset audit */
export const ASSET_AUDIT_ROUTE = {
  SEGMENT: 'asset-audit',
  PROCESS: 'new-asset-audit-process',
  NEW_ASSET_AUDIT: 'new-asset-audit',
  VARIANCE: 'variance',
  ACKNOWLEDGE: 'acknowledge',
} as const;

/** Key audit */
export const KEY_AUDIT_ROUTE = {
  SEGMENT: 'key-audit',
  PROCESS: 'key-audit-process',
  VERIFICATION: 'key-verification',
  VARIANCE_CHECK: 'variance-check',
  ACKNOWLEDGE: 'acknowledge',
} as const;

/** Branch audit */
export const BRANCH_AUDIT_ROUTE = {
  PROCESS: 'branch-audit-process',
  FILL_FORM: 'fill-form',
  ACKNOWLEDGE: 'acknowledge',
} as const;

/** Surveillance (routine / loan process) */
export const SURVEILLANCE_ROUTE = {
  ROUTINE_CHECKING: 'routine-checking',
  LOAN_PROCESS_CHECKING: 'loan-process-checking',
  AUDIT_PROCESS: 'audit-process',
} as const;
